import { Header } from "components/layout/Header";
import { VMMFooter } from "components/layout/VMMFooter";
import { VMMHeader } from "components/layout/VMMHeader";
import { Outlet, useOutletContext } from "react-router-dom";

interface Props {}

export function AppLayout(props: Props) {
  const context = useOutletContext();

  return (
    <>
      <VMMHeader />
      <Header />
      <Outlet context={context} />
      <VMMFooter />
    </>
  );
}
